import { Col, Row, Typography, Form, Space, Spin, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import {
  ExclamationCircleOutlined
} from "@ant-design/icons";
import {
  ReactSelectField,
} from "../../atoms/FormElement";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getACLGroups, getUserList } from "./ducks/actions"
import SectionHeader from "../../molecules/SectionHeader";
import AddACLGroup from "./components/AddACLGroup"
import { Popup } from "../../atoms/Popup";
import { api } from "../../../services/api";

const { Title, Paragraph } = Typography;

const defaultVal = {
  group: "",
  userId: "",
};

const ControlCenter = (props) => {

  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [trigger, setTrigger] = useState(0);
  const [visible, setVisible] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [submited, setSubmited] = useState(false);

  const userList = useSelector(
    (state: any) => state.controlCenter.userList,
  );

  const aclGroupList = useSelector(
    (state: any) => state.controlCenter.aclGroupList,
  );

  const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    defaultValues: defaultVal,
  });

  useEffect(() => {
    dispatch(getACLGroups())
    dispatch(getUserList())
  }, [])

  const addACLGroup = () => {
    navigate(`/add-control-center`, { state: { isDisabledAll: true, isLease: true } });
  }


  const onSubmit = () => {
    return;
  }

  const popup = [
    {
      closable: true,
      title: (
        <Title level={3} className="mb-0">
          Create ACL Group
        </Title>
      ),
      content: (
        <AddACLGroup
          onSubmit={() => onSubmit()}
          onCancel={() => setVisible(false)} />
      ),
      width: 680,
    }
  ];

  const popupProps = {
    closable: trigger == 0 ? true : false,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  const onFinish = async (values) => {
    setLoader(true);
    setSubmited(true);

    const postJson = {
      "userId": values.user?.value,
      "groupId": values.group?.value
    }
    console.log(postJson);

    // return
    try {
      const res = await api.assignGroupUser(postJson)
      console.log(res);

      setTimeout(() => {
        reset();
        setLoader(false);
        message.success("Group assigned successfully");
        setSubmited(false);
        props.onSubmit();
      }, 3000);

    } catch (e) {
      console.log(e);

      setLoader(false);
      setisError(true);
      const { message } = e;
      setErrorMessage(message);
    }
  }

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <SectionHeader heading="ACL Groups"
            noBorder={true}
            addNewAction={addACLGroup}
            addText={'ACL Group'}
            // addMoreButton={addUser}
            // addMoreText={`Add New User`}
            // searchOptions={searchOptions}
            searchName='Category'
            justifiedItems={true}
            justifyEnd={true}
          // onChange={(e) => {searchTrigger(e)}}
          // exportAction2={onClickExport}
          />
        </Col>
        <Col span={24}>
          <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
            {loader && !isError && (
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Space size={24} className="w-100 text-center" direction="vertical">
                    <Spin size="large" className="ag-fontSize32" />
                    {/* <Paragraph className="ag-default fontWeight600 mb-0">Loading</Paragraph> */}
                  </Space>
                </Col>
              </Row>
            )}
            {!submited ? (
              <>
                <Row gutter={24} style={{ marginTop: 13 }}>

                  <Col span={8}>
                    <ReactSelectField
                      isRequired={true}
                      fieldname="group"
                      label="Select ACL Group"
                      control={control}
                      iProps={{
                        placeholder: "Select ACL Group",
                        isDisabled: !aclGroupList?.length,
                      }}
                      rules={{
                        required: "Please select ACL group",
                      }}
                      initValue=""
                      selectOption={
                        aclGroupList?.map((item) => ({
                          value: item?._id,
                          label: item?.name,
                        }))
                      }
                      validate={errors.group && "error"}
                      validMessage={
                        errors.group && errors.group.message
                      }
                    />
                  </Col>

                  <Col span={8}>
                    <ReactSelectField
                      isRequired={true}
                      fieldname="user"
                      label="Select User"
                      control={control}
                      iProps={{
                        placeholder: "Select User",
                        isDisabled: !userList?.length,
                      }}
                      rules={{
                        required: "Please select user",
                      }}
                      initValue=""
                      selectOption={
                        userList?.map((item) => ({
                          value: item?._id,
                          label: item?.name,
                        }))
                      }
                      validate={errors.userId && "error"}
                      validMessage={
                        errors.userId && errors.userId.message
                      }
                    />
                  </Col>

                  <Col span={8} style={{ display: 'flex', alignItems: 'center', paddingTop: 10 }}>
                    <Button className="ag-green-button" htmlType="submit">
                      Assign Group
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              isError && (
                <>
                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <Space
                        size={24}
                        className="w-100 text-center"
                        direction="vertical"
                      >
                        <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                        <Paragraph className="ag-error fontWeight600 mb-0">
                          {errorMessage}
                        </Paragraph>
                      </Space>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: 20 }}>
                      <Button
                        className="ag-gray-button-outline"
                        htmlType="button"
                        onClick={() => {
                          setSubmited(false);
                          setisError(false);
                        }}
                      >
                        Back
                      </Button>
                    </Col>
                  </Row>
                </>
              )
            )}
          </Form>
        </Col>
      </Row>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};

export default ControlCenter;
